import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconDiamondsFilled(props: IconProps) {
	return (
		<Icon fill="currentColor" {...props}>
			<path d="M12 2.005c-.777 0 -1.508 .367 -1.971 .99l-5.362 6.895c-.89 1.136 -.89 3.083 0 4.227l5.375 6.911a2.457 2.457 0 0 0 3.93 -.017l5.361 -6.894c.89 -1.136 .89 -3.083 0 -4.227l-5.375 -6.911a2.446 2.446 0 0 0 -1.958 -.974z" />
		</Icon>
	);
}
